import React from "react";
import { useTheme } from "styled-components";
import SignupBoxMobile from "./Mobile/SignupBoxMobile";
import SignupBoxWeb from "./Web/SignupBoxWeb";
import { useWindowSize } from "../../../../context/WindowSizeContext";

const SignupBox = () => {
  const size = useWindowSize();
  const theme = useTheme();
  const isMobile = size.width! <= parseInt(theme.breakpoints.mobileL);

  return isMobile ? <SignupBoxMobile /> : <SignupBoxWeb />;
};

export default SignupBox;
